export default __webpack_public_path__ + "static/media/transaction.4ad7bbc2.svg";